import React, { useState, Fragment, useEffect } from "react";
import {closeBtn, formBtn1,formBtn2,inputClass,labelClass} from "../Utils/CustomClasses";
import { useForm, Controller } from "react-hook-form";
import { Dialog, Transition } from "@headlessui/react";
import { customStyles } from "../Utils/CommonFuntion";
import Error from "../Error/Error";
import { Tooltip } from "antd";
import {validateEmail,validateFirstName,validateLastName,validatePassword,validatePhoneNumber} from "../Utils/Validation";
import Select from "react-select";
import { useSelector } from "react-redux";
import {AssignUserAPI,GetAllRolesAPI,RegisterUserAPI,UpdateAdminUserAPI,} from "../../API/Api";
import { toast } from "react-toastify";
import ButtonLoader from "../Loader/ButtonLoader";
import { IconEdit, IconEye, IconEyeOff, IconInfoCircle } from "@tabler/icons-react";

export default function AddEmploye({ edit, filterRecords, rowdata, Company }) {
    const {register,handleSubmit,control,reset,formState: { errors },setValue} = useForm();
    const UserDetails = useSelector((state) => state?.login?.userDetails);
    const [isOpen, setIsOpen] = useState(false);
    const [AssignUsers, setAssignUsers] = useState([]);
    const [eyeIcon, setEyeIcon] = useState(false);
    const [loader, setLoader] = useState(false);
    const [RolesList, setRolesList] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState("");

    const assignToOptions =
        AssignUsers != undefined
            ? AssignUsers.map((user) => ({
                value: user?._id,
                label: `${user?.first_name} ${user?.last_name}`,
            }))
            : [{ value: "", label: "No data found" }];

    let timeoutId;
    const handleAssignChange = (selectedOption) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(async () => {
            try {
                let response = await AssignUserAPI({
                    id: UserDetails?._id,
                    role: UserDetails?.role?.roleName,
                    search: selectedOption,
                    company:
                        UserDetails?.role?.roleName === "Admin"
                            ? UserDetails?.company?._id
                            : selectedCompanyId,
                });
                if (edit) {
                    const filteredData = response?.data?.filteredData?.filter(
                        (user) => user?._id !== rowdata?._id
                    );
                    setAssignUsers(filteredData);
                } else{
                setAssignUsers(response?.data?.filteredData);
                }
            } catch (error) {
                console.error("Error assigning user:", error);
            }
        }, 1500);
    };

    const fetchRolesList = async (companyId) => {
        try {
            const response = await GetAllRolesAPI(companyId);
            setRolesList(response?.data?.filteredData);
        } catch (err) {
            console.error("Error fetching roles:", err);
        }
    };

    const handleCompanySelect = async (id) => {
        let companyId;
        companyId = UserDetails?.role?.roleName == "Admin" ? UserDetails?.company._id : id;
        setSelectedCompanyId(companyId);
        setValue("assign_to", null); 
        setAssignUsers([]);
        try {
            fetchRolesList(companyId);
            let response2 = await AssignUserAPI({
                id: UserDetails?._id,
                role: UserDetails?.role?.roleName,
                company: companyId,
            });
            if (edit){
                const filteredData = response2?.data?.filteredData?.filter(
                    (user) => user?._id !== rowdata?._id
                );
                setAssignUsers(filteredData);
            }else{
            setAssignUsers(response2?.data?.filteredData);
            }
        } catch (err) {
            console.log("Error", err);
        }
    };

    const toggle = () => {
        setIsOpen(!isOpen);
        reset();
    };

    const onSubmit = async (data) => {
        setLoader(true);
        const updatedPayload = {
            ...data,
            assign_to: data.assign_to?.value, 
        };
        try {
            let response;
            if (edit == true) {
                response = await UpdateAdminUserAPI(rowdata?._id, updatedPayload);
            } else {
                response = await RegisterUserAPI(updatedPayload);
            }
            if (response?.status == 201) {
                setLoader(false);
                toast.success(response?.data?.message);
                toggle();
                filterRecords();
                setAssignUsers([]);
            } else {
                setLoader(false);
                toast.error(response?.error);
            }
        } catch (err) {
            setLoader(false);
            console.log("err", err);
        }
    };

    useEffect(() => {
        if (isOpen && UserDetails?.role?.roleName == "Admin") {
            handleCompanySelect(UserDetails?.company?._id);
        }
        if (isOpen && edit === true) {
            reset({
                first_name: rowdata?.first_name,
                last_name: rowdata?.last_name,
                email: rowdata?.email,
                assign_to: rowdata?.assign_to
                    ? {
                        value: rowdata?.assign_to?._id,
                        label: `${rowdata?.assign_to?.first_name} ${rowdata?.assign_to?.last_name}`,
                    }
                    : null,
                phone_number: rowdata?.phone_number,
                company: rowdata?.company?._id,
            });
            setTimeout(() => {
                setValue("role", rowdata?.role?._id);
            }, 500);
        }
        if (isOpen && edit === false && UserDetails?.role?.roleName !== "SuperAdmin") {
            setTimeout(() => {
                setValue("company", UserDetails?.company?._id);
            }, 500);
        }
        if (isOpen && edit === true && UserDetails?.role?.roleName !== "Admin") {
            fetchRolesList(rowdata?.company?._id);
        }
    }, [isOpen]);

    return (
        <>
            {edit ? (
                <button
                    onClick={toggle}
                    className="py-1 rounded-lg flex justify-center w-[24%]"
                >
                    <IconEdit stroke={1.5} size={28} color="#000" />
                </button>
            ) : (
                <button onClick={toggle} className={formBtn1}>
                    Add Employee
                </button>
            )}

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={() => {}} >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll ">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >
                                        {edit ? "Edit Employee" : "Add Employee"}
                                    </Dialog.Title>
                                    <div>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="p-2">
                                                <div className="grid py-4 mx-4 md:grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 customBox">
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            First Name<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            {...register("first_name", {validate: validateFirstName })}
                                                        />
                                                        {errors?.first_name && <Error title={errors?.first_name?.message} />}
                                                    </div>
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Last Name<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            {...register("last_name", {validate: validateLastName })}
                                                        />
                                                        {errors?.last_name && <Error title={errors?.last_name?.message} />}
                                                    </div>
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Company Name
                                                            <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select
                                                            className={inputClass}
                                                            {...register("company", { required: true })}
                                                            onChange={(e) =>
                                                                handleCompanySelect(e.target.value)
                                                            }
                                                            disabled={UserDetails?.role?.roleName !== "SuperAdmin"}
                                                        >
                                                            <option value="">Select Company Name</option>
                                                            {Company?.map((company) => (
                                                                <option
                                                                    value={company?._id}
                                                                    key={company?._id}
                                                                >
                                                                    {company?.companyName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.company && (
                                                            <Error title="Company Name is Required*" />
                                                        )}
                                                    </div>
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Assign To<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <div className="form-group">
                                                            <Controller
                                                                name="assign_to"
                                                                control={control}
                                                                rules={{ required: "assign to is Required*" }}
                                                                render={({ field }) => (
                                                                    <Select
                                                                        value={field.value || null}
                                                                        options={assignToOptions}
                                                                        placeholder="Select User"
                                                                        isClearable={true}
                                                                        styles={customStyles}
                                                                        maxMenuHeight={150}
                                                                        menuPlacement="auto"
                                                                        noOptionsMessage={()=>"User not available"}
                                                                        onChange={(selectedOption) => {
                                                                            field.onChange(selectedOption); // Update form state
                                                                            handleAssignChange(selectedOption); // Call custom function
                                                                        }}
                                                                        onInputChange={(inputValue, { action }) => {
                                                                            if (action === "input-change") {
                                                                                handleAssignChange(inputValue); // Call function on typing
                                                                            }
                                                                        }}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    {errors.assign_to && (
                                                            <Error title={errors.assign_to.message} />
                                                        )}
                                                    </div>
                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Role<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select
                                                            className={inputClass}
                                                            {...register("role", { required: true })}
                                                        >
                                                            <option value="">Select Role</option>
                                                            {RolesList && RolesList.length > 0 ? (
                                                                RolesList.filter(
                                                                    (role) => role?.roleName != "Admin"
                                                                )?.map((role) => (
                                                                    <option value={role?._id} key={role?._id}>
                                                                        {role?.roleName}
                                                                    </option>
                                                                ))
                                                            ) : (
                                                                <option value="">No Roles Found</option>
                                                            )}
                                                        </select>
                                                        {errors.role && <Error title="Role is Required*" />}
                                                    </div>

                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Email<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            {...register("email", {
                                                                validate: validateEmail,
                                                            })}
                                                        />
                                                        {errors.email && (
                                                            <Error title={errors.email.message} />
                                                        )}
                                                    </div>
                                                    {edit == false && (
                                                        <div className="">
                                                            <label className={`${labelClass} flex`}>
                                                                Password<span style={{ color: "red" }}>*</span>
                                                                <span className="ml-1">
                                                                    <Tooltip
                                                                        title={
                                                                            <>
                                                                                <div>
                                                                                    Password must contain at least first
                                                                                    letter uppercase one special character
                                                                                    and one number
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        placement="right"
                                                                        color="#032037"
                                                                    >
                                                                        <IconInfoCircle stroke={2} size="20" color="#000" />
                                                                    </Tooltip>
                                                                </span>
                                                            </label>
                                                            <div className="relative flex items-center mt-1">
                                                                <input
                                                                    className={inputClass}
                                                                    type={!eyeIcon ? "password" : "test"}
                                                                    {...register("password", {
                                                                        required: "Password is required",validate: validatePassword
                                                                    })}
                                                                />
                                                                <span
                                                                    className="absolute z-10 right-2 "
                                                                    onClick={() => setEyeIcon(!eyeIcon)}
                                                                >
                                                                    {eyeIcon ? (
                                                                        <IconEye stroke={1.5} size={24} color="#000" className="cursor-pointer" />
                                                                    ) : (
                                                                        <IconEyeOff stroke={1.5} size={24} color="#000" className="cursor-pointer" />
                                                                    )}
                                                                </span>
                                                            </div>
                                                            {errors.password && (
                                                                <Error title={errors.password.message} />
                                                            )}
                                                        </div>
                                                    )}

                                                    <div className="">
                                                        <label className={labelClass}>
                                                            Phone Number
                                                            <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            {...register("phone_number", {
                                                                validate: validatePhoneNumber,
                                                            })}
                                                        />
                                                        {errors.phone_number && (
                                                            <Error title={errors.phone_number.message} />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                                {loader ? (
                                                    <ButtonLoader />
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                                                    >
                                                        <span className="opacity-100">
                                                            {edit ? "Update" : "Submit"}
                                                        </span>
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    className={closeBtn}
                                                    onClick={toggle}
                                                >
                                                    Close
                                                </button>
                                            </footer>
                                        </form>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
